import { QueryFilters } from '@tanstack/react-query';
import { DashboardItemDto } from '@unistocks/proxy/axios-client';
import { dashboardGetAssetListDataQueryKey } from '@unistocks/proxy/axios-client/DashboardQuery';

export const queryFilter = ({ id }: DashboardItemDto): QueryFilters => ({
  queryKey: dashboardGetAssetListDataQueryKey(id)
});
